import * as constants from '../constants/common.constants';
import { AppDispatch } from '../store';

export const setLoginPopup = (payload: any) => (dispatch: AppDispatch) => {
  dispatch({ type: constants.LOGIN_POPUP, payload });
};

export const setLocationPopup = (payload: any) => (dispatch: AppDispatch) => {
  dispatch({ type: constants.LOCATION_POPUP, payload });
};

export const setSearchPopup = (payload: any) => (dispatch: AppDispatch) => {
  dispatch({ type: constants.SEARCH_POPUP, payload });
};

export const setArtistPopup = (payload: any) => (dispatch: AppDispatch) => {
  dispatch({ type: constants.ARTIST_POPUP, payload });
};

export const setSelectedTicket = (payload: any) => (dispatch: AppDispatch) => {
  dispatch({ type: constants.TICKET_POPUP, payload });
};
